module.exports = __webpack_public_path__ + "img/1f40c.b7960ce.svg";